(() => {
  const setupStickyAddToCart = (root = document) => {
    root.querySelectorAll('[data-ce-sticky-atc]').forEach((bar) => {
      if (bar.dataset.ceReady === 'true') return;
      bar.dataset.ceReady = 'true';

      const sectionId = bar.dataset.sectionId;
      const productInfo = bar.closest('product-info');
      const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const mainPrice = document.getElementById(`price-${sectionId}`);
      const stickyButton = bar.querySelector('[data-ce-sticky-button]');
      const stickyButtonText = bar.querySelector('[data-ce-sticky-button-text]');
      const stickyPrice = bar.querySelector('[data-ce-sticky-price]');
      const stickyVariant = bar.querySelector('[data-ce-sticky-variant]');
      const mobile = window.matchMedia('(max-width: 749px)');

      if (!productInfo || !mainButton || !stickyButton) return;

      let productVisible = false;
      let mainButtonAboveViewport = false;

      const sync = (variant) => {
        stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        stickyButton.toggleAttribute('aria-busy', mainButton.classList.contains('loading'));

        const buttonLabel = mainButton.querySelector('span')?.textContent?.trim();
        if (buttonLabel && stickyButtonText) stickyButtonText.textContent = buttonLabel;

        const currentPrice =
          mainPrice?.querySelector('.price-item--sale')?.textContent?.trim() ||
          mainPrice?.querySelector('.price-item--regular')?.textContent?.trim();
        if (currentPrice && stickyPrice) stickyPrice.textContent = currentPrice;

        if (variant && stickyVariant) {
          const hasNamedVariant = variant.title && variant.title !== 'Default Title';
          stickyVariant.textContent = hasNamedVariant ? variant.title : '';
          stickyVariant.classList.toggle('hidden', !hasNamedVariant);
        }
      };

      const updateVisibility = () => {
        const show = mobile.matches && productVisible && mainButtonAboveViewport;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
      };

      const productObserver = new IntersectionObserver((entries) => {
        productVisible = entries[0]?.isIntersecting ?? false;
        updateVisibility();
      });

      const buttonObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        mainButtonAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        updateVisibility();
      });

      productObserver.observe(productInfo);
      buttonObserver.observe(mainButton);

      const stateObserver = new MutationObserver(() => sync());
      stateObserver.observe(mainButton, { attributes: true, childList: true, subtree: true });
      if (mainPrice) stateObserver.observe(mainPrice, { childList: true, subtree: true });

      if (mobile.addEventListener) {
        mobile.addEventListener('change', updateVisibility);
      } else {
        mobile.addListener(updateVisibility);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== sectionId) return;
          sync(event.data.variant);
        });
      }

      sync();
    });
  };

  document.addEventListener('DOMContentLoaded', () => setupStickyAddToCart());
  document.addEventListener('shopify:section:load', (event) => setupStickyAddToCart(event.target));
})();
